import './Subiecte.css';

export default function Subiecte2027() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2027{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2027/SubiectModel2027MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2027/SubiectModel2027MIPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2027/BaremModel2027MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2027/SubiectModel2027SNC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2027/SubiectModel2027SNPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2027/BaremModel2027SN.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}